import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Spinner } from 'react-bootstrap';
import apiclient from "../../../Api/ApiClient";
// import 'bootstrap/dist/css/bootstrap.css';
import apiClient from '../../../Api/ApiClient';
import apis from '../../../Api/api.json';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TopHeader } from "../TopHeader/TopHeader";
import { CmsFooter } from "../Footer/CmsFooter";
import CmsDisplay from "../Header/CmsDisplay";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'; // Import Material-UI components
import { Link, useParams } from 'react-router-dom';
import { Row } from 'react-bootstrap/esm';
import { BASE_URL } from '../../../Api/ApiFunctions';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export const Editform3data = () => {
    const { id } = useParams()
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [formErrors, setFormErrors] = useState({});
    const [successDialogOpen, setSuccessDialogOpen] = useState(false);
    const [getuser, setuser] = useState('');
    const [selectedFile, setSelectedFile] = useState({});
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        SNo: '',
        pcmreview_cata: [],
        pcmnumber_catb: [],
        pcmreview_catb: [],
        pcmnumber_catb: [],
        attended_cat_a: '',
        date_attended_cat_a: '',
        attended_cat_b: '',
        date_attended_cat_b: '',
        part3: '',
        admin_remark: ''
    });

    // New state variables for confirmation dialog and loading
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [loading, setLoading] = useState(false);


    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };



    const handleSubmit = async (event) => {
        event.preventDefault();

        setConfirmDialogOpen(true);
    };

    const handleDeleteCancel = () => {
        // Handle cancel action in the confirmation dialog
        setConfirmDialogOpen(false);
    };

    const handleDeleteConfirm = async () => {
        // Close the confirmation dialog
        setConfirmDialogOpen(false);
        // Set loading state to true
        setLoading(true);

        try {


            let candidateId = 0;
            if (localStorage.getItem("candidateId")) {
                candidateId = localStorage.getItem("candidateId");
            }
            else {
                candidateId = 0;
            }


            const formDataToSend = new FormData();
            formDataToSend.append('id', id);
            formDataToSend.append('Attended_CAT_A', formData.attended_cat_a);
            formDataToSend.append('Date_Attended_CAT_A', formData.date_attended_cat_a);
            formDataToSend.append('Attended_CAT_B', formData.attended_cat_b);
            formDataToSend.append('Date_Attended_CAT_B', formData.date_attended_cat_b);

            const response = await apiclient.post(apis.Tppaobspart3, formDataToSend)

            if (response.status === 200) {
                console.log("user" + response.data)
                navigate("/form3part1list");
                // Simulate a 3-second delay
                setTimeout(() => {
                    // Set loading state back to false after the delay
                    setLoading(false);
                    // Show the success dialog
                    setSuccessDialogOpen(true);

                    setFormData({
                        SNo: '',
                        StationName: '',
                        kVLevel: '',
                        Owner: '',
                        Location: '',
                        PlannedDateAudit: '',
                        DateAudit: '',
                        AuditEntity: '',
                        Report: '',
                        Compliances: '',
                        Issuesobserved: '',
                        Remarks: '',
                        CAT_A_deficiencies: '',
                        attended_cat_a: '',
                        date_attended_cat_a: '',
                        CAT_B_deficiencies: '',
                        attended_cat_b: '',
                        BDate_Attended: ''
                    });
                    setSelectedRole('');
                }, 1000);
            } else if (response.status === 500) {
                alert("User already exists");

            }

            else {
                alert('Something went wrong');
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            toast.error('Something went wrong');
            setLoading(false);
        }
    };

    useEffect(() => {
        async function fetchData2() {
            try {

                //const response = await apiClient.get(`/api/FormReports/Ttppaobservation/${id}`);
                const response = await apiClient.get(`/api/TPPAObservations/Getalldata/${id}`);
                setFormData(response.data);

            } catch (error) {
                console.error('Error fetching user data:', error);

            }
        }
        fetchData2();
    }, [id]);



    return (
        <>
            <div>
                <div>
                    <TopHeader />

                </div>

                <CmsDisplay />
                <main >

                    <div class="main-form">
                        <div class="container-fluid">
                            <div class="InnerSection">
                                <div class="InnerSectionBox">
                                    <Form className="forms-sample" onSubmit={handleSubmit}>
                                        <h4>TPPA Observations/descripancies</h4>
                                        <tbody>
                                            <tr>
                                                <td className="ui header">S.No</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Serial no" value={formData.id} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header" >Station Name</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Station Name" value={formData.station_name} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">KV Level</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="KV Level" value={formData.kv_level} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Utility</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Owner" value={formData.owner} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Location</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Location" value={formData.location} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Planned Date of Audit</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Planned Date of Audit" value={formData.planned_date_of_audit} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Date of Audit</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Date of Audit" value={formData.date_of_audit} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Audit Entity</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Audit Entity" value={formData.date_of_audit} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Reports</td>
                                                <td>
                                                    {/* <input className="form-control" type="file" accept=".pdf" onChange={handleFileChange} placeholder="Reports" value={formData.reportpdfpath} disabled   /> */}
                                                    <Link className="form-control" to={`${BASE_URL + formData.reportpdfpath}`} ><PictureAsPdfIcon /></Link>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Compliances</td>
                                                <td>
                                                    <Link className="form-control" to={`${BASE_URL + formData.compliancesppath}`} ><PictureAsPdfIcon /></Link>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Issues Observed</td>
                                                <td>
                                                    <Link className="form-control" to={`${BASE_URL + formData.issues_observedpath}`} ><PictureAsPdfIcon /></Link>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">Remarks</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Remarks" value={formData.remarks} disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ui header">CAT A Deficiencies</td>
                                                <td colSpan="3">
                                                    <ul className="list-group" style={{ pointerEvents: "none", backgroundColor: "#e9ecef" }}>
                                                        {formData.cat_a_deficiencies?.split(',').map((item, index) => {
                                                            const pcmNumbers = formData.pcmnumber_cata?.split(',') || [];
                                                            const pcmReviews = formData.pcmreview_cata?.split(',') || [];

                                                            return (
                                                                <li key={index} className="list-group-item d-flex align-items-center">
                                                                    {/* Read-Only Deficiency Name */}
                                                                    <span style={{ flex: 1 }}>{item.trim()}</span>

                                                                    {/* PCM Number Input (Editable by Admin) */}
                                                                    <input
                                                                        className="form-control mx-2"
                                                                        type="text"
                                                                        placeholder="PCM Number"
                                                                        value={pcmNumbers[index]?.trim() || ""}
                                                                        name={`pcm_number_cata_${index}`}
                                                                        onChange={handleChange}
                                                                        style={{ width: "120px" }}
                                                                    />

                                                                    {/* PCM Review Input (Editable by Admin) */}
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="PCM Review"
                                                                        value={pcmReviews[index]?.trim() || ""}
                                                                        name={`pcmreview_cata_${index}`}
                                                                        onChange={handleChange}
                                                                        style={{ width: "200px" }}
                                                                    />
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </td>


                                            </tr>

                                            <tr>
                                                <td className="ui header">Attended Y/N</td>
                                                <td>
                                                    {formData.attended_cat_a === "1" ? (
                                                        // Show Disabled Input for "Yes"
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="attended_cat_a"
                                                            value="Yes"
                                                            disabled
                                                        />
                                                    ) : (
                                                        // Show Dropdown for Selection
                                                        <select
                                                            className="form-control"
                                                            name="attended_cat_a"
                                                            value={formData.attended_cat_a || ""}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    )}
                                                </td>

                                            </tr>

                                            <tr>
                                                <td className="ui header">Date Attended</td>
                                                <td>
                                                    {formData.attended_cat_a === "1" ? (
                                                        formData.date_attended_cat_a ? (
                                                            // Show text input when date_attended_cat_a has a value
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="date_attended_cat_a"
                                                                value={formData.date_attended_cat_a ? new Date(formData.date_attended_cat_a).toLocaleDateString("en-GB") : ""}
                                                                onChange={handleChange}
                                                                disabled
                                                            />
                                                        ) : (
                                                            // Show date input when date_attended_cat_a is null
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                name="date_attended_cat_a"
                                                                value={formData.date_attended_cat_a || ""}
                                                                onChange={handleChange}
                                                            />
                                                        )
                                                    ) : formData.attended_cat_a === "2" ? (
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="date_attended_cat_a"
                                                            value={formData.date_attended_cat_a || ""} // If null, show empty
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    ) : (
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="date_attended_cat_a"
                                                            value={formData.date_attended_cat_a || ""} // If null, show empty
                                                            onChange={handleChange}
                                                        />
                                                    )}

                                                </td>

                                            </tr>


                                            <tr>
                                                <td className="ui header">CAT B Deficiencies</td>
                                                <td colSpan="3">
                                                    <ul className="list-group" style={{ pointerEvents: "none", backgroundColor: "#e9ecef" }}>
                                                        {formData.cat_b_deficiencies?.split(',').map((item, index) => {
                                                            const pcmNumbers = formData.pcmnumber_catb?.split(',') || [];
                                                            const pcmReviews = formData.pcmreview_catb?.split(',') || [];

                                                            return (
                                                                <li key={index} className="list-group-item d-flex align-items-center">
                                                                    {/* Read-Only Deficiency Name */}
                                                                    <span style={{ flex: 1 }}>{item.trim()}</span>

                                                                    {/* PCM Number Input (Editable by Admin) */}
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="PCM Number"
                                                                        value={pcmNumbers[index]?.trim() || ""}
                                                                        name={`pcm_number_catb_${index}`}
                                                                        onChange={handleChange}
                                                                        style={{ width: "150px", marginLeft: "10px" }}
                                                                    />

                                                                    {/* PCM Review Input (Editable by Admin) */}
                                                                    <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        placeholder="PCM Review"
                                                                        value={pcmReviews[index]?.trim() || ""}
                                                                        name={`pcm_review_catb_${index}`}
                                                                        onChange={handleChange}
                                                                        style={{ width: "200px", marginLeft: "10px" }}
                                                                    />
                                                                </li>
                                                            );
                                                        })}
                                                    </ul>
                                                </td>

                                            </tr>
                                            <tr>
                                                <td className="ui header">Attended Y/N Cat B</td>
                                                <td>
                                                    {formData.attended_cat_b === "1" ? (
                                                        // Disabled input when "Yes"
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="attended_cat_b"
                                                            value="Yes"
                                                            disabled
                                                        />
                                                    ) : (
                                                        // Dropdown when "No"
                                                        <select
                                                            className="form-control"
                                                            name="attended_cat_b"
                                                            value={formData.attended_cat_b || ""}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="1">Yes</option>
                                                            <option value="2">No</option>
                                                        </select>
                                                    )}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="ui header">Date Attended Cat B</td>
                                                <td>
                                                    {formData.attended_cat_b === "1" ? (
                                                        // Show Disabled Input with Date if Yes is Selected
                                                        formData.date_attended_cat_b ? (
                                                            // Show text input when date_attended_cat_a has a value
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="date_attended_cat_b"
                                                                value={formData.date_attended_cat_b ? new Date(formData.date_attended_cat_b).toLocaleDateString("en-GB") : ""}
                                                                onChange={handleChange}
                                                                disabled

                                                            />
                                                        ) : (
                                                            // Show date input when date_attended_cat_a is null
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                name="date_attended_cat_b"
                                                                value={formData.date_attended_cat_b || ""}
                                                                onChange={handleChange}
                                                            />
                                                        )
                                                    ) : formData.attended_cat_b === "2" ? (
                                                        // Show Disabled Empty Input if No is Selected
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="date_attended_cat_b"
                                                            value={formData.date_attended_cat_b || ""}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    ) : (
                                                        // Show Calendar Input when "Yes" is Selected from Dropdown
                                                        <input
                                                            className="form-control"
                                                            type="date"
                                                            name="date_attended_cat_b"
                                                            value={formData.date_attended_cat_b || ""}
                                                            onChange={handleChange}
                                                        />
                                                    )}
                                                </td>
                                            </tr>



                                            <tr>
                                                <td className="ui header" hidden={formData.part3 != 1}>Admin Remark</td>
                                                <td>
                                                    <input className="form-control" type="text" placeholder="Admin Remark" value={formData.admin_remark} name="admin_remark" onChange={handleChange} hidden={formData.part3 != 1} />
                                                </td>
                                            </tr>
                                        </tbody>



                                        <div
                                            id="button"
                                            className="d-flex justify-content-center mt-3"
                                        >
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="px-4 py-2 fw-bold shadow-sm"
                                                style={{
                                                    width: "150px",
                                                    backgroundColor: "#007bff",
                                                    borderColor: "#0056b3",
                                                    borderRadius: "8px",
                                                    color: "white",
                                                    fontSize: "16px",
                                                    transition: "0.3s",
                                                }}
                                                onMouseOver={(e) => {
                                                    e.target.style.backgroundColor = "#0056b3";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.backgroundColor = "#007bff";
                                                }}
                                            >
                                                Update Data
                                            </Button>
                                        </div>


                                        <Dialog className="backdrop" open={confirmDialogOpen} onClick={handleDeleteCancel}>
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </Spinner>
                                        </Dialog>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CmsFooter />
                </main>
            </div >
            <ToastContainer />
            {/* Confirmation Dialog */}
            <Dialog open={confirmDialogOpen} onClose={handleDeleteCancel}>
                <DialogTitle>Confirm Create</DialogTitle>
                <DialogContent>
                    Are you sure you want to submit ?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Success Dialog */}
            <Dialog
                open={successDialogOpen}
                onClose={() => setSuccessDialogOpen(false)}
            >
                <DialogTitle>Success</DialogTitle>
                <DialogContent>Saved successfully!</DialogContent>
                <DialogActions>
                    <Button onClick={() => setSuccessDialogOpen(false)} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}


